var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup6440(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.598,
    height: 284.405,
    viewBox: "0 0 400.598 284.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d6dbdf;}.b{fill:#f7f7f7;}.c{fill:#bacff5;}.d{fill:url(#a);}.e{fill:#fff;}.f{fill:url(#b);}.g{fill:url(#c);}.h{fill:url(#d);}.i{fill:url(#e);}.j{fill:url(#f);}.k{fill:#f0a494;}.l{opacity:0.2;}.m{fill:url(#h);}.n{fill:url(#i);}.o{fill:url(#j);}.p{fill:url(#k);}.q{fill:#2b3648;}.r{fill:url(#l);}.s{opacity:0.15;}.t{fill:url(#o);}.u{fill:#4b5b6d;}.v{fill:#37465b;}.w{fill:url(#q);}.x{fill:url(#t);}.y{fill:url(#u);}.z{fill:#dd8c7f;}.aa{fill:url(#w);}.ab{fill:url(#aa);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b2330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.507,
    y1: 1.148,
    x2: 0.494,
    y2: -0.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf0fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.502,
    y1: 0.99,
    x2: 0.498,
    y2: 0.036,
    href: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.477,
    y1: 0.031,
    x2: 0.522,
    y2: 0.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c2ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.969,
    y1: 0.496,
    x2: 0.012,
    y2: 0.504,
    href: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    href: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.907,
    y1: 0.015,
    x2: 0.238,
    y2: 0.874,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.155,
    y1: 1.012,
    x2: 0.803,
    y2: 0.17,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.317,
    y1: 0.96,
    x2: 0.656,
    y2: 0.131,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6778c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#93a6e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.527,
    y1: 1.235,
    x2: 1.4,
    y2: 1.235,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    href: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.404,
    y1: 0.977,
    x2: 0.505,
    y2: 0.064,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.538,
    y1: 1.097,
    x2: 0.444,
    y2: 0.059,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5cc5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedfb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0.438,
    y1: 0.69,
    x2: 1.272,
    y2: 1.645,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.789,
    y1: 1.054,
    x2: 0.129,
    y2: 0.052,
    href: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -0.145,
    y1: 0.117,
    x2: 0.828,
    y2: 0.983,
    href: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    href: "#q"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-584.392 -355.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.392 355.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.077 12.965)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 157.566,
    height: 117.475,
    rx: 15.449,
    transform: "translate(16.864 3.536)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 157.566,
    height: 117.475,
    rx: 15.449,
    transform: "translate(12.936 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 6.759,
    height: 36.361,
    transform: "translate(85.192 34.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 6.759,
    height: 23.775,
    transform: "translate(100.576 47.316)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 6.759,
    height: 23.775,
    transform: "translate(115.493 35.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 6.759,
    height: 15.85,
    transform: "translate(130.877 43.121)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29.835,
    height: 2.797,
    transform: "translate(54.379 85.076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 20.512,
    height: 2.797,
    transform: "translate(54.379 93.001)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 20.512,
    height: 2.797,
    transform: "translate(54.379 100.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M952.419,389.967v4.778H794.853v-4.778a7.579,7.579,0,0,1,7.576-7.576H944.844A7.579,7.579,0,0,1,952.419,389.967Z",
    transform: "translate(-781.918 -382.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M815.677,393.26c0,1.156-.937,1.7-2.093,1.7s-2.093-.544-2.093-1.7a2.093,2.093,0,1,1,4.186,0Z",
    transform: "translate(-790.398 -386.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M832.754,393.26c0,1.156-.938,1.7-2.093,1.7s-2.093-.544-2.093-1.7a2.093,2.093,0,1,1,4.186,0Z",
    transform: "translate(-799.101 -386.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M849.829,393.26c0,1.156-.937,1.7-2.093,1.7s-2.093-.544-2.093-1.7a2.093,2.093,0,1,1,4.186,0Z",
    transform: "translate(-807.804 -386.864)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 64.28,
    height: 18.526,
    rx: 9.263
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 64.28,
    height: 18.526,
    rx: 9.263,
    transform: "translate(0 27.649)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 9.263,
    cy: 9.263,
    r: 9.263,
    transform: "translate(45.894 0.14)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.036 97.83)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 111.626,
    height: 97.045,
    rx: 21.535,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1063.564,705.7v12.822A10.558,10.558,0,0,1,1053,729.082H962.5a10.558,10.558,0,0,1-10.559-10.559V705.7Z",
    transform: "translate(-951.937 -632.037)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.235 23.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M969.86,638.53l-1.128-1.094c.45-.464,11.109-11.3,19.605-5.638l.576.386c4.266,2.865,8.3,5.571,14.539-.305,4.471-4.209,11.086-11.148,15.039-15.541,4.455-4.951,11.009-6.067,18.95-3.231.367.131.746.271,1.137.413,6.906,2.533,16.364,6,25.07-9.116l1.362.784c-4.117,7.148-8.832,11.052-14.416,11.933-4.729.746-9.071-.846-12.558-2.126-.386-.142-.761-.279-1.125-.408-5.085-1.817-12.206-2.8-17.253,2.8-3.975,4.416-10.628,11.4-15.13,15.634-7.156,6.735-12.116,3.4-16.492.465l-.572-.383C980.058,628.168,969.962,638.426,969.86,638.53Z",
    transform: "translate(-968.732 -604.405)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.136 81.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 31.678,
    height: 1.572
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.136 87.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 21.621,
    height: 1.572
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.99)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M667.377,837.189l-3.273,3.4-4.357,4.526-5.944-5.724L659.138,833l1.733-2.078Z",
    transform: "translate(-625.951 -664.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M663.622,860.91l-4.7-12.371s-5.909.309-6.124-5.9l-4.864,2.649a1.074,1.074,0,0,0-.231,1.717l15.037,14.485A.54.54,0,0,0,663.622,860.91Z",
    transform: "translate(-622.675 -669.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M617.4,799.978l-4.754,2.7-4.817,2.731-4.067-7.178,7.249-4.821,1.933-1.285Z",
    transform: "translate(-600.447 -644.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M624.935,799.978l-4.754,2.7-1.635-9.268,1.933-1.285Z",
    transform: "translate(-607.982 -644.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M672.923,837.189l-3.273,3.4L664.684,833l1.733-2.078Z",
    transform: "translate(-631.497 -664.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M665.207,667.026l-.66,24.912L618.2,728.819l7.465,12.572,59.072-44.208,8.129-28.322Z",
    transform: "translate(-607.806 -580.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M722.308,661.143l-1.087,31.392a16.049,16.049,0,0,1-3.37,9.3l-42.188,54.243-11.787-10.216,35.226-54.82-1.574-25.962Z",
    transform: "translate(-631.085 -577.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M753.419,539.122l-.323-9.129s9.985,0,1.712-16.261c0,0-1.712-2.567-2.568-2.567s-8.558-2-9.414,7.987l2,9.7-.856,10.27Z",
    transform: "translate(-671.323 -500.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M844.97,497.353a39.056,39.056,0,0,1-6.82,3.933c-1.835.785-7.6,1.312-7.6,1.312L808,523.052l-3.909,2.522-4.22,2.723-1.575-9.441.357-.252,4.887-3.422,21.24-14.552,6.821-10.1s1.049,1.312-.786,5.245l7.866,1.049,6.817-1.312A2.06,2.06,0,0,1,844.97,497.353Z",
    transform: "translate(-699.593 -490.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M804.086,554.754l-4.22,2.723-1.575-9.441.358-.251Z",
    transform: "translate(-699.592 -519.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M739.622,565.12l.782,45.552s-19.535,9.449-37.659,3.017c-.121-.04-.243-.087-.365-.13l1.049-25.176a.462.462,0,0,1-.048.008,21.136,21.136,0,0,1-3.614.251c-2.935-.059-6.566-.864-6.566-4.455,0-6.031,13.634-26.748,17.044-28.583s21.24-1.049,21.24-1.049l13.146-7.1,5.477,12.211-10.49,5.116Z",
    transform: "translate(-646.031 -519.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M608.446,821.165l-.986-13.2s-5.753-1.384-4.194-7.4l-5.416,1.157a1.074,1.074,0,0,0-.71,1.58l10.3,18.163A.54.54,0,0,0,608.446,821.165Z",
    transform: "translate(-597 -648.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M743.453,510.471a31.1,31.1,0,0,1-3.43.963l2.283,5.135-.57.57s-3.139-2-3.709-.287.857,3.426,3.139,4c0,.075-.024,5.135-6.278,5.135-1.372,0-6.365-2.939-6.365-11.583,0,0-.024,0-.063,0-.256,0-1.171-.027-1.509,0a1.544,1.544,0,0,1-.189.012c-6.53.436-4.495-7.115-.99-10.227,2.015-1.792,3.9-.138,5.155,1.615a15.953,15.953,0,0,1,1.025,1.678c.008.012.012.028.019.039,1.764-1.639,6.907-4.495,11.481-1.368C744.632,506.955,746.9,509.324,743.453,510.471Z",
    transform: "translate(-660.961 -497.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M736.389,509.959c-.055,1.453-.719,3.8-3.493,6.919-.255,0-1.171-.028-1.509,0a1.528,1.528,0,0,1-.189.012c1.587-1.375,4.491-4.483,4.165-8.612A15.886,15.886,0,0,1,736.389,509.959Z",
    transform: "translate(-665.397 -499.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M712.949,593.153c-.075.362-1.359,9.964-2.742,18.529a21.112,21.112,0,0,1-3.614.251C707.967,607.5,709.538,600.657,712.949,593.153Z",
    transform: "translate(-652.856 -542.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M750.324,628.641s-19.535,9.449-37.659,3.017c10.942-.389,35.258-6.1,36.779-48.947l.1.377Z",
    transform: "translate(-655.951 -537.514)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.05 139.683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1323.354,918.743l-10.9,2.785-6,1.536-2.357-9.822,6.542.2,6.031.189Z",
    transform: "translate(-1199.44 -779.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1312.459,921.528l-6,1.536-2.357-9.822,6.542.2Z",
    transform: "translate(-1199.44 -779.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1342.775,918.3l-12.454-4.473s.2-5.913-6.01-6.016l2.561-4.911a1.075,1.075,0,0,1,1.713-.263l14.755,14.772A.54.54,0,0,1,1342.775,918.3Z",
    transform: "translate(-1209.74 -774.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1200.335,809.151l6.614,47.687a7.058,7.058,0,0,0,7.049,6.089l42.325-.343V850.8l-33-5.7s5.7-38.7.982-52.452Z",
    transform: "translate(-1146.553 -718.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1136.856,906.832l-.385,5.367-.4,5.634h-8.25v-11Z",
    transform: "translate(-1109.594 -776.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1136.856,906.832l-.385,5.367-8.651,1.206v-6.573Z",
    transform: "translate(-1109.594 -776.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1158.916,794.652l-31.137,1.926a7.23,7.23,0,0,0-6.78,7.416l1.379,49.984h12.18l3.928-38.5s44,13.359,44.79-18.073Z",
    transform: "translate(-1106.115 -719.226)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1103.092,927.708l11.966-5.65s4.041,4.322,8.5,0l1.665,5.282a1.075,1.075,0,0,1-1.025,1.4h-20.878A.54.54,0,0,1,1103.092,927.708Z",
    transform: "translate(-1096.833 -784.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1105.535,706.555l-3.929,3.536-2.73-3.992-1.084-1.583-1.293-1.89a9.939,9.939,0,0,1-1.241-.361A7.979,7.979,0,0,1,1091,699.09s-.786-3.536,0-5.893c0,0,3.929-3.929,5.5-4.715l.979,3.155,2.557,8.239.378.46,2.86,3.473Z",
    transform: "translate(-1090.649 -665.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1093.364,701.8l4.715-15.323,2.357.786-4.322,15.323Z",
    transform: "translate(-1092.032 -664.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1105.2,701.128a10.551,10.551,0,0,1-2.621,4.18l-1.292-1.89a9.942,9.942,0,0,1-1.242-.361v0c.133-1.737,2.224-6.9,2.224-6.9a8.061,8.061,0,0,1,0-3.721,8.767,8.767,0,0,1,.789-2.173c.393-.786,1.179.786,1.179.786a34.589,34.589,0,0,0,.786,5.893A6.209,6.209,0,0,1,1105.2,701.128Z",
    transform: "translate(-1095.439 -665.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M1105.337,680.068l-2.357,3.143,2.357.786Z",
    transform: "translate(-1096.933 -660.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1174.974,674.472l-8.6,4.471c0-.209-.507-3.076-.907-5.3-.193-1.089-.362-2.02-.429-2.409-.027-.13-.039-.2-.039-.2s-13.068,8.6-9.971-14.1c0,0,1.375-5.5,11.347-2.409a9.942,9.942,0,0,1,4.816,7.567Z",
    transform: "translate(-1123.218 -647.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1160.917,656.105s.688-2.751,2.751-2.408.344,4.471,0,5.159c0,0,3.654,3.858,6.814,1.585s3.848-12.247-2.343-14.311c0,0,.344-7.223-11.694-4.815-2.428.486-10.318,5.847-3.44,9.287,2.752,1.376,7.567.344,7.567.344l-.687,5.159Z",
    transform: "translate(-1121.028 -640.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1114.086,722.487l-3.929,3.536-2.731-3.992,4.4-2.291Z",
    transform: "translate(-1099.2 -681.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1179.821,747.447s-8.188-2.157-20.234,1.375c-3.544,1.037-10.215-.393-13.359-6.286,0,0,3.43-10.675-3.229-24.14q-.147-.306-.307-.613l-.047.055-.295.35-10.887,12.946a4.841,4.841,0,0,1-7.036.4l-19.845-18.855,6.286-7.858,14.734,11.2,12.2-17.507a10.3,10.3,0,0,1,3.422-3.1l9.523-5.327s22.694,6.258,29.035,57.052C1179.794,747.239,1179.809,747.345,1179.821,747.447Z",
    transform: "translate(-1097.75 -665.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1178.47,682.072a14.691,14.691,0,0,1-2.106,6.094c-.193-1.088-.362-2.019-.429-2.408A6.927,6.927,0,0,0,1178.47,682.072Z",
    transform: "translate(-1134.117 -661.847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.755,746.175l.149.251-.295.35Z",
    transform: "translate(-1137.009 -694.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1219.753,776.876s-8.188-2.157-20.234,1.375c-3.544,1.037-10.216-.393-13.359-6.286,0,0,3.43-10.675-3.229-24.139,2.754,4.326,8.533,25.122,36.782,28.74C1219.726,776.668,1219.742,776.774,1219.753,776.876Z",
    transform: "translate(-1137.682 -695.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1391.5,721.811l-6.683,4.84-3.072-4.239-3.383-4.668,7.32-5.3,1.949,3.135Z",
    transform: "translate(-1266.413 -537.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1374.225,742l6.375-11.6s5.808,1.129,6.886-4.989l4.448,3.3a1.075,1.075,0,0,1-.011,1.733l-16.907,12.25A.54.54,0,0,1,1374.225,742Z",
    transform: "translate(-1264.267 -544.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1395.246,654.444l-4.7.129-6.3.173L1384,645.71l4.86.216,6.161.271Z",
    transform: "translate(-1269.284 -503.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1390.548,654.573l-6.3.173L1384,645.71l4.86.216Z",
    transform: "translate(-1269.284 -503.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1405.46,664.746l-5.977-11.806s4.21-4.159-.234-8.5l5.235-1.809a1.075,1.075,0,0,1,1.425.986l.573,20.87A.54.54,0,0,1,1405.46,664.746Z",
    transform: "translate(-1277.057 -502.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M1296.776,558.373l-10.821,40.913a6.314,6.314,0,0,0,5.258,7.871l46.854,6.3-.3-13.293-30.646-6.679.292-33.057Z",
    transform: "translate(-1219.206 -459.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1387.633,715.576l-5.885,6.837-3.383-4.668,7.32-5.3Z",
    transform: "translate(-1266.413 -537.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M1318.083,570.023c-.011.8.009,26.286.016,35.188a9.953,9.953,0,0,0,1.7,5.549L1345.6,649.1l12.18-8.251-21.222-38.131,1.4-33.9Z",
    transform: "translate(-1235.687 -464.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M1266.011,468.388l-4.691,1.383-5.269,1.556-8.84-29.27,4.322-1.572,9.579,20.022h3.2Z",
    transform: "translate(-1199.567 -399.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1280.676,489.2l-4.691,1.383.475-9.264h2.515Z",
    transform: "translate(-1214.232 -419.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1285.821,477.409l-8.52,1.278,1.7,9.16h7.456Z",
    transform: "translate(-1214.903 -417.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1293.818,452.125l-8.73,2.287-.522-5.293-.252-2.534-.012-.125c-12.007,3.54-8.129-16.553-8.129-16.553l13.535.079,1.7,11.508Z",
    transform: "translate(-1214.024 -393.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1284.821,433.4s2.553-3.528.4-4.055a2.6,2.6,0,0,0-2.992,1.594l-.843-1.028s1.74-4.867.524-5.3-9.855.917-9.8-2.858,1.144-8.391,6.543-5.653c.425.216.7.22,1.933-.439,1.995-1.063,3.431.339,4.213,1.991a1.4,1.4,0,0,0,1.841.5c1.852-.708,4.271-1.783,5.272.835,1.252,3.273-1.367,4.275.693,5.738s1.625,2.68,1.189,3.9-1.617,3.62-1.741,4.867-2.241,3.558-4.363,2.719A6.742,6.742,0,0,1,1284.821,433.4Z",
    transform: "translate(-1212.259 -386.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1324.571,517.873s-10.019,2.785-15.409,1.646c-10.33-2.184-12.5,1.336-12.5,1.336s-1.839-15.732-3.214-25.99c-.719-5.344-1.685-11.021-1.933-15.916-.193-3.847.059-7.21,1.229-9.552.024-.055.055-.114.083-.169,0,0,2.479,2.735,8.015-5.571,0,0,16.84,2.388,23.719,54.152C1324.567,517.83,1324.567,517.854,1324.571,517.873Z",
    transform: "translate(-1222.119 -410.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 56.305,
    height: 48.326,
    rx: 13.126
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1324.632,532.812s-10.019,2.786-15.409,1.646c-10.329-2.184-12.5,1.336-12.5,1.336s-1.839-15.732-3.214-25.99c-.719-5.344-1.686-11.021-1.933-15.916.145-.31.294-.617.444-.919-.082.774-3.01,30.288,32.6,39.78C1324.628,532.769,1324.628,532.792,1324.632,532.812Z",
    transform: "translate(-1222.18 -425.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1259.059,472.28l-6.891,2.491-4.011,1.446a3.75,3.75,0,0,1-4.683-1.961L1231.608,448.5l-3.623-4.047-1.277-3.41c-.428-1.065,0-1.277,0-1.277a.834.834,0,0,1,.853-1.065c-.212-1.277,1.064-.853,1.064-.853-.428-1.277,1.065-1.277,1.065-1.277l2.341,2.129,1.7,2.554a2.283,2.283,0,0,1,2.77-1.277l-2.13,4.259,1.276,3.41,14.058,19.386,1.623-.684,2.428-1.021Z",
    transform: "translate(-1189.021 -397.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1284.855,502.17l-6.892,2.491c-.258-2.656-.593-5.988-.832-8.42l2.428-1.021Z",
    transform: "translate(-1214.816 -426.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1166.516,410.822h39.723l-14.421-20.844-7.866,11.8-4.85-4.588Z",
    transform: "translate(-1158.439 -373.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1277.3,486.371l15.856-8.251a6.012,6.012,0,0,1,7.932,2.24h0a6.013,6.013,0,0,1-2.687,8.576l-17.48,7.874Z",
    transform: "translate(-1214.903 -417.869)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 4.719,
    cy: 4.719,
    r: 4.719,
    transform: "translate(8.339 11.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1296.878,458.513a11.365,11.365,0,0,1-3.229,5.186l-.252-2.534A8.624,8.624,0,0,0,1296.878,458.513Z",
    transform: "translate(-1223.107 -408.223)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.386 187.385)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M851.371,759.776a24.188,24.188,0,0,0-2.247-5.617l1.926-4.493-6.74-6.58-4.494,1.926a21.638,21.638,0,0,0-5.617-2.247l-1.6-4.654h-9.469l-1.766,4.654a24.139,24.139,0,0,0-5.617,2.247l-4.494-1.926-6.58,6.58,1.926,4.493a21.646,21.646,0,0,0-2.247,5.617l-4.654,1.766v9.469l4.654,1.766a24.156,24.156,0,0,0,2.247,5.617l-1.926,4.494,6.741,6.58,4.494-1.926a21.664,21.664,0,0,0,5.617,2.247l1.765,4.654h9.309l1.766-4.654a24.2,24.2,0,0,0,5.617-2.247l4.494,1.926,6.74-6.58-1.926-4.494a21.671,21.671,0,0,0,2.247-5.617l4.654-1.766v-9.469Zm-23.592,17.975A11.555,11.555,0,1,1,839.334,766.2,11.507,11.507,0,0,1,827.779,777.751Z",
    transform: "translate(-799.693 -738.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M885.8,857.628a7.77,7.77,0,0,0,0-2.728l1.6-1.6-1.6-4.012h-2.247a21.9,21.9,0,0,0-1.926-1.926V845.11l-4.012-1.6-1.6,1.6a7.8,7.8,0,0,0-2.728,0l-1.6-1.6-4.012,1.6v2.247a21.9,21.9,0,0,0-1.926,1.926h-2.247l-1.6,4.012,1.6,1.6a7.77,7.77,0,0,0,0,2.728l-1.6,1.6,1.6,4.012h2.247a21.7,21.7,0,0,0,1.926,1.926v2.247l4.012,1.605,1.6-1.605a7.77,7.77,0,0,0,2.728,0l1.6,1.605,4.012-1.605v-2.247a21.861,21.861,0,0,0,1.926-1.926H885.8l1.6-4.012ZM872.957,861a5.186,5.186,0,1,1,6.741-2.889A5.132,5.132,0,0,1,872.957,861Z",
    transform: "translate(-831.389 -791.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M928.673,814.75a7.788,7.788,0,0,0,0-2.728l1.6-1.6-1.6-4.013h-2.247a21.822,21.822,0,0,0-1.926-1.925v-2.247l-4.013-1.6-1.6,1.6a7.8,7.8,0,0,0-2.728,0l-1.6-1.6-4.013,1.6v2.247a21.87,21.87,0,0,0-1.926,1.925h-2.247l-1.605,4.013,1.605,1.6a7.776,7.776,0,0,0,0,2.728l-1.605,1.605,1.605,4.012h2.247a21.812,21.812,0,0,0,1.926,1.926v2.247l4.013,1.6,1.6-1.6a7.8,7.8,0,0,0,2.728,0l1.6,1.6,4.013-1.6v-2.247a21.726,21.726,0,0,0,1.926-1.926h2.247l1.6-4.012Zm-13,3.531a5.186,5.186,0,1,1,6.74-2.889A5.026,5.026,0,0,1,915.674,818.281Z",
    transform: "translate(-853.243 -769.973)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6440);
export default __webpack_public_path__ + "static/media/Group 6440.c1e4d0f8dc942906b114ecef417c7ce2.svg";
export { ForwardRef as ReactComponent };